import styled from '@emotion/styled'

import { colors } from '../../constants/colors'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  > div {
    display: flex;
    flex-direction: column;
    max-width: 475px;
    width: 100%;
    row-gap: 24px;
    align-items: center;
    text-align: center;
    @media (max-width: 780px) {
      max-width: 320px;
      row-gap: 16px;
    }
  }
  img {
    max-width: 389px;
    width: 100%;
    margin-bottom: 18px;
  }
  .title {
    color: ${colors.$secondary};
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    @media (max-width: 780px) {
      font-size: 24px;
      line-height: 28px;
    }
  }
  .info {
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    color: ${colors.$primary2};
    @media (max-width: 780px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  button {
    max-width: 320px;
    text-transform: none;
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    @media (max-width: 780px) {
      font-size: 18px;
      line-height: 20px;
    }
  }
`
